module.exports = __webpack_public_path__ + "img/11.2c86b7a2.jpg";